import { graphql } from '@/client/services/api/graphql/gql';

export const updateWorkflowResultGroupMutation: any = graphql(`
  mutation UpdateWorkflowResultGroup(
    $id: String!
    $resultGroupUpdateInput: ResultGroupUpdateInput!
  ) {
    updateResultGroup(id: $id, resultGroupUpdateInput: $resultGroupUpdateInput) {
      id
      __typename
    }
  }
`);
